<template>
  <ul class="ticketType">
    <li>
      <div class="title">
        <img src="~@/assets/image/common/common_modification.png" alt="">
        <div class="title-content">
          <span class="text">Date of Use</span>
        </div>
      </div>
      <div class="date">
        <div
            class="item"
            @click="clickDays(item, index)"
            :class="{
              'currentDate' : !item.ticketState,
              'currentTicket' : currentIndex1 === index
            }"
            v-for="(item, index) in topThreeSaleDateInfos"
            :key="item.saleDate">
          <div class="text">{{ $getDaysEn(item.saleDate) }}</div>
          <div class="time">{{ $sieveMonthDayEn(item.saleDate) }}</div>
          <img v-if="currentIndex1 === index" src="~@/assets/image/common/common_select.png" alt="">
        </div>
        <div
          :class="{ 'currentTicket' : currentIndex1 === 3 }"
          v-if="saleDateInfos.length > 3"
          @click="clickMore"
          class="more">
          <div class="text">More Dates</div>
          <div class="time" v-if="moreState">{{ currentDays.saleDate }}</div>
          <img v-if="currentIndex1 === 3" src="~@/assets/image/common/common_select.png" alt="">
        </div>
      </div>
    </li>
    <li v-if="currentDatePeriodInfos.length">
      <div class="title">
        <img src="~@/assets/image/common/common_modification.png" alt="">
        <div class="title-content">
          <span class="text">Time slots for ticket scanning</span>
        </div>
      </div>
      <div class="date">
        <div class="item"
            :class="{
              'currentDate' : parseInt(item1.resourceCount) === 0,
              'currentTicket' : currentIndex2 === index1
            }"
            v-for="(item1, index1) in currentDatePeriodInfos"
            :key="item1.periodId"
            @click="clickTimeInterval(item1, index1)"
            >
          <div class="period">{{ item1.periodStartTime }}~{{ item1.periodEndTime }}</div>
          <div class="moreThan">{{ item1.resourceCount }}</div>
          <img v-if="currentIndex2 === index1" src="~@/assets/image/common/common_select.png" alt="">
        </div>
      </div>
    </li>
    <li v-else class="msg">No available time slots for today, please select another date.</li>
    <moredate
      v-if="isNeedPeriod"
      ref="sonMoredate"
      @clickClose="clickClose"
      :maskSatus="maskSatus"
      :saleDateInfos="saleDateInfos"
      :currentGroup="{
        currentDays,
        currentTime,
        activeDate: currentIndex1,
        activeTimeInterval: currentIndex2,
      }"
    >
    </moredate>
  </ul>
</template>

<script>
import moredate from '@/components/buyTickets/common/moredateEn'
export default {
  name: "ticketType",
  props: {
    saleDateInfos:{
      default(){
        return []
      }
    },
  },
  data(){
    return {
      disableDate:['2024-10-15','2024-10-16','2024-10-17','2024-10-18','2024-10-19','2024-10-20'],
      currentIndex1: null,
      currentIndex2: null,
      maskSatus: false,
      currentDatePeriodInfos: [],
      moreState: false,
      // 维护两个数据
      // 1、整体天数
      currentDays: null,
      // 2、时间段
      currentTime: null,
      // 购票时是否需要时段
      isNeedPeriod: true,
      todayList:null,
    }
  },
  methods: {
    clickDays(item, index){
      console.log(item)
      if(item.islp && this.disableDate.includes(item.saleDate)) return this.$toast('Suzhou Street building protection, joint tickets temporarily suspended from sale');
      if(item.isClosed) return this.$toast('The ticket package is unavailable because the in-park attractions are closed on Mondays. Please book an entrance ticket instead.');
      if(item.needDatePeriod && !item.datePeriodInfos.length)return this.$toast('Ticket purchase is unavailable today.');
      if(item.needDatePeriod && this.saleDateInfos[index].datePeriodInfos.every(item => item.resourceCount == '0'))return this.$toast('Not enough remaining tickets');
      if(item.needDatePeriod && !this.saleDateInfos[index].datePeriodInfos.length)return this.$toast('Not enough remaining tickets');
      if(!item.needDatePeriod) {
        this.isNeedPeriod = false
      }
      this.todayList = item
      this.currentIndex1 = index;
      this.currentIndex2 = null;
      this.currentDatePeriodInfos = item.datePeriodInfos;
      this.currentDays = item;
      this.currentTime = null;
      this.moreState = false;
      this.$emit('changeSeasonTicket', this.currentDays)
    },
    clickTimeInterval(periodStartTime, index){
      if(periodStartTime.resourceCount == 0)return this.$toast('Not enough remaining tickets');
      this.currentTime = periodStartTime;
      this.currentIndex2 = index;
    },
    clickMore(){
      console.log(this.isNeedPeriod)
      this.maskSatus = true;
    },
    clickClose(item = null){
      if(item){
        const { currentIndex1 } = item;
        this.currentDatePeriodInfos = item.selectItem.datePeriodInfos;
        this.currentDays = item.selectItem;
        this.todayList = item.selectItem;
        this.currentTime = item.selectGroup
        this.currentIndex2 = item.selectItem.datePeriodInfos.findIndex(item1 => item.selectGroup.periodId === item1.periodId);
        if(currentIndex1 <= 2){
          this.currentIndex1 = currentIndex1;
          this.moreState = false;
        }else{
          this.currentIndex1 = 3;
          this.moreState = true;
        };
        this.$emit('changeSeasonTicket', this.currentDays)
      }
      this.maskSatus = false;
    },
  },
  computed: {
    topThreeSaleDateInfos(){
      return this.saleDateInfos.slice(0, 3);
    },
  },
  watch:{
    saleDateInfos: {
      handler(newvalue){
        // console.log(newvalue)
        if(!newvalue.length) return
        console.log(this.currentIndex1)
        const needperiodFlag = newvalue.every(item => item.needDatePeriod == false)
        console.log(needperiodFlag)
        let dataIndex
        // console.log(needperiodFlag)
        if(needperiodFlag) {
          this.isNeedPeriod = false
          this.todayList = this.currentDays = newvalue[0];
          console.log(newvalue)
          console.log(this.currentDays)
          this.currentTime = null
          this.currentIndex2 = null;
          this.currentIndex1 = 0;
        }else{
           this.isNeedPeriod = true
           // 维护状态添加有票高亮
          dataIndex = newvalue.findIndex(item => item.datePeriodInfos && item.datePeriodInfos.length && item.datePeriodInfos.some(v => parseInt(v.resourceCount) > 0));
          console.log(dataIndex)
        }
       
        
        if(dataIndex !== -1 && !needperiodFlag){
          console.log('test')
          this.todayList = newvalue[0]
          this.currentDays = newvalue[dataIndex];
          console.log(dataIndex)
          console.log(this.currentIndex1)
           if(dataIndex == 0) {
            this.currentDatePeriodInfos = this.currentTime = newvalue[dataIndex].datePeriodInfos;
            this.currentIndex1 = dataIndex;
            this.currentIndex2 = this.currentTime.findIndex(v => parseInt(v.resourceCount) > 0);
          }
          console.log(this.currentIndex1)
          // this.currentDatePeriodInfos = this.currentTime = newvalue[dataIndex].datePeriodInfos;
          // this.currentIndex1 = dataIndex;
          // this.currentIndex2 = this.currentTime.findIndex(v => parseInt(v.resourceCount) > 0);
          this.$emit('changeSeasonTicket', this.currentDays)
        };
      },
      immediate: true
    },
  },
  components:{
    moredate
  }
};
</script>

<style scoped lang='less'>
.ticketType {
  padding: .333333rem;
  background: #ffffff;
  li:nth-child(2),
  li:last-child {
    margin-top: 0.32rem;
    .item:last-child {
      margin: 0;
    }
  }
  .title {
    line-height: 1;
    display: flex;
    align-items: center;
    img{
      width: .533333rem;
      margin-right: .133333rem;
    }
    .title-content{
      .text {
        font-weight: bold;
        color: #000000;
        font-size: .426667rem;
      }
      .msg {
        color: rgba(58, 62, 92, 0.7);
        font-size: 0.32rem;
        margin-left: 0.266667rem;
      }
    }
  }
  .date {
    display: flex;
    margin-top: 0.213333rem + 0.106667rem;
    line-height: 1;
    & > .item,
    & > .more {
      height: 0.746667rem * 2;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid rgba(151, 151, 151, 0.07);
    }
    .item {
      margin-right: 0.213333rem;
      flex-direction: column;
      border-radius: 0.16rem;
      color: #333333;
      box-shadow: 0 0.026667rem 0.053333rem 0 rgba(0, 0, 0, 0.06);
      width: 25%;
      .text{
        font-size: 0.4rem;
        line-height: .373333rem;
      }
      .period {
        font-size: .266667rem;
        line-height: .373333rem;
      }
      .time,
      .moreThan {
        font-size: .373333rem;
        line-height: .533333rem;
      }
    }
    .more {
      width: 25%;
      font-size: .373333rem;
      color: #333333;
      border-radius: 0.16rem;
      display: flex;
      flex-direction: column;
      box-shadow: 0 .026667rem .053333rem 0 rgba(0,0,0,0.06);
      .time{
        font-size: 0.32rem;
        margin-top: 0.106667rem;
      }
    }
    .currentDate {
      background: rgba(153, 153, 153, .5);
      & > * {
        color: #ffffff !important;
      }
    }
    .currentTicket {
      background: rgba(237, 192, 132, 0.35);
      color: #9D6C29;
      border: 1px solid #9D6C29;
      position: relative;
      img{
        width: .346667rem;
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
  }
  .msg{
    font-size: 0.32rem;
    line-height: 0.48rem;
  }
}
</style>
